export class EnaioObjectLimit {
    typeId = 0;
    max = 0;
}
